export default __webpack_public_path__ + "7553d41554e578da65267da15786e3e0.svg";